import { apiClient } from '../../gateways/api'
import type { FetchValuelists } from '../types/FetchValuelists'

export { fetchValuelists, initialState }

const initialState: FetchValuelists = {
  data: {
    gebieden: [],
    aannemers: [],
    uitvoerendeAannemers: [],
    coordinerenden: [],
    realisatietypes: [],
    actiehouders: [],
    activiteittypes: [],
    activiteitTemplates: [],
  },
}

const fetchValuelists = async (): Promise<FetchValuelists['data']> => {
  const { data } = await apiClient({
    url: '/rest/valuelist',
    method: 'GET',
  })
  return data
}
